export enum ReceiveType {
  Station = "STATION", //khách tới kho lấy
  Door = "DOOR", //Giao tận nhà
}

export const ReceiveTypeTrans = {
  [ReceiveType.Station]: { label: "Delivery to station", color: "blue" },
  [ReceiveType.Door]: { label: "Delivery to door", color: "purple" },
};
